var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"LLTableColumn",class:_vm.styleHeaderSorting,style:(_vm.columnWidth),attrs:{"data-e2e":_vm.columnField}},[_c('div',{staticClass:"LLTableColumn-inner"},[_vm._t("table-column",function(){return [_vm._v(" "+_vm._s(_vm.columnLabel)+" ")]},{"column":_vm.column})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }